/**
 * Check if the credit card has expired or not. If the month or year is not provided, it will return true.
 * @param {String | Number} month expiration month
 * @param {String | Number} year expiration year
 * @returns if the credit card is expired
 */
export function isCreditCardExpired(month, year) {
  if (!month || !year) {
    return true;
  }

  const date = new Date();
  const currentYear = String(date.getFullYear());
  const currentMonth = String(date.getMonth() + 1).padStart(2, '0');
  const cardExpYear = year.toString().padStart(4, '2020');
  const cardExpMonth = month.toString().padStart(2, '0');

  return Number(cardExpYear + cardExpMonth) < Number(currentYear + currentMonth);
}
